import { create, is } from "superstruct";
import {
  PostEntitlementErrorResponseStruct,
  PostEntitlementErrorResponseType,
  PostEntitlementResponseStruct,
  PostEntitlementResponseType,
  PostEntitlementType,
} from "@features/ottPurchase/types/PostEntitlementApi";
import {
  GetOfferApiProps,
  GetOfferErrorResponseStruct,
  GetOfferErrorResponseType,
  GetOfferResponseStruct,
  GetOfferResponseType,
} from "@features/ottPurchase/types/GetOfferApi";
import { webExperienceApi } from "@motain/web-shared-hub/services";

export const ottPurchaseApi = webExperienceApi.injectEndpoints({
  endpoints: (builder) => ({
    getOffer: builder.query<GetOfferResponseType, GetOfferApiProps>({
      query: ({ offerId, locale, environment }) => ({
        // remove hardcoded value
        url: `${locale}/tv-hub/v1/cleeng/offers/${offerId}`,
        params: {
          env: environment,
        },
      }),
      transformResponse: (response) => {
        return create(
          response,
          GetOfferResponseStruct,
          "Fail to create getOffer response",
        );
      },
      transformErrorResponse: (response): GetOfferErrorResponseType => {
        if (!is(response.data, GetOfferErrorResponseStruct)) {
          return {
            error: {
              type: "Unknown Error",
              title: "Unknown error occurred",
              message: "Unknown error occurred",
            },
          };
        }
        return response.data;
      },
    }),
    postEntitlement: builder.mutation<
      PostEntitlementResponseType,
      PostEntitlementType
    >({
      query: ({ offerId, locale, environment }) => ({
        // remove hardcoded value
        url: `${locale}/tv-hub/v1/cleeng/offers/${offerId}/entitlements`,
        params: {
          env: environment,
        },
        method: "POST",
      }),
      transformResponse: (response) => {
        return create(
          response,
          PostEntitlementResponseStruct,
          "Fail to create checkEntitlement response",
        );
      },
      transformErrorResponse: (response): PostEntitlementErrorResponseType => {
        if (!is(response, PostEntitlementErrorResponseStruct)) {
          return {
            error: {
              type: "Unknown Error",
              title: "Unknown error occurred",
              message: "Unknown error occurred",
            },
          };
        }
        return response;
      },
    }),
  }),
});

export const { useGetOfferQuery, usePostEntitlementMutation } = ottPurchaseApi;
